import { Dispatch } from "redux";
import { MultiLanguageWrapper } from "@iddataweb/idw-common-ui/types";
import { AxnCompany, AxnRelyingParty } from "@idw-types/data/reference-data/axn";
import { addMessagingTemplate } from "@redux/actions/messaging-templates-actions";
import { createMessagingTemplateRequest } from "@requests/axnadmin-core/create-messaging-template";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";
import { MessagingTemplateTypes } from "@enums/messaging-template-types";
import { formatMessagingTemplateConfiguration } from "@formatters/messaging-template-configurations/messaging-template-configuration-formatter";
import { MessagingTemplate, MessagingTemplateConfiguration } from "@idw-types/data/messaging-template";
import { addObjectsToArrayInCommonReferenceData } from "@redux/actions/common-reference-data-actions";

export const createMessagingTemplateReduxRequest = (dispatch: Dispatch) => async (
    template: string,
    name: string,
    companyId: string,
    relyingPartyId: string,
    type: MessagingTemplateTypes,
    languageFiles: Partial<MultiLanguageWrapper<string>>,
    axnCompanies: Array<AxnCompany>,
    axnRelyingParties: Array<AxnRelyingParty>,
    addToReferenceData: boolean
): Promise<MessagingTemplate> => {
    const { data, error, body } = await createMessagingTemplateRequest(
        template,
        name,
        companyId,
        relyingPartyId,
        type,
        languageFiles
    );

    if (data) {
        const languages = Object.keys(data.languageFiles).join(",");

        const messagingTemplateConfiguration: MessagingTemplateConfiguration = {
            companyID: data.companyID,
            dateCreated: null,
            dateLastModified: null,
            id: data.id,
            languages: languages,
            name: data.name,
            relyingPartyID: data.relyingPartyID,
            status: data.status,
            type: data.type,
            uuid: data.uuid,
            permissions: {
                canModify: true,
                canView: true
            }
        };

        if (addToReferenceData) {
            dispatch(addObjectsToArrayInCommonReferenceData([messagingTemplateConfiguration], "messagingTemplates"));
        } else {
            const formattedMessagingTemplate = formatMessagingTemplateConfiguration(
                messagingTemplateConfiguration,
                axnCompanies,
                axnRelyingParties
            );
            dispatch(addMessagingTemplate(formattedMessagingTemplate));
        }

        displaySuccessModal(
            dispatch,
            resources.requests.createMessagingTemplate.success.title,
            resources.requests.createMessagingTemplate.success.message
        );
        return data;
    } else if (error) {
        logAndDisplayErrorModal(
            dispatch,
            error,
            resources.requests.createMessagingTemplate.error.title,
            resources.requests.createMessagingTemplate.error.message,
            null,
            null,
            body
        );
    }

    return null;
};